// Only coalesce in-flight reads. Never cache a quote used for submitting a transaction.
const reads = new WeakMap()
export function sharedMerchantRead(query, account, provider, force = false) {
    let accounts = reads.get(query)
    if (!accounts) { accounts = new Map(); reads.set(query, accounts) }
    const previous = accounts.get(account)
    if (!force && previous?.provider === provider) return previous.promise
    const entry = { provider, promise: null }
    // Invoke now to preserve the contract reader's synchronous argument capture.
    try { entry.promise = Promise.resolve(query(account)) } catch (error) { entry.promise = Promise.reject(error) }
    accounts.set(account, entry)
    const clear = () => { if (accounts.get(account) === entry) accounts.delete(account) }
    entry.promise.then(clear, clear)
    return entry.promise
}
